import { useCallback, useState } from 'react'

const useModal = (initial = false) => {
  const [isOpen, setIsOpen] = useState(initial)
  return [isOpen, useCallback((status) => setIsOpen(() => status), [])]
}

export default useModal
